namespace Nobox.CRM {
    export class TaskcontactsColumns {
        static columnsKey = 'Nobox.Taskcontacts';
    }
}
